import { Consumer } from '~/constants/common/consumer';
import type { AppliedFilters } from '~/contracts/common';
import { getHrefWithSource } from '~/hooks/common/selectors/useGetConsumerHref';
import generateSearchLinkFilter from '~/utilities/generateSearchFilterLink';

const getHomeHref = getHrefWithSource(Consumer.HOME);

export default function buildHomeSearchRedirectUrl(
  filters: Partial<AppliedFilters>
): string {
  const searchLink = generateSearchLinkFilter({ filters });

  return getHomeHref(searchLink);
}
